export default __webpack_public_path__ + "static/chris-21ca2b82e081f3bd5f2070c0af1cd390.jpg";